module.exports = "<div class=\"dbm-edit\">\n    <ng-content></ng-content>\n    <div class=\"dbm-edit-footer\" *ngIf=\"!withoutButton\">\n        <button class=\"btn btn-default save\" (click)=\"save.emit()\" [disabled]=\"saveDisabled\">Save</button>\n        <button class=\"btn btn-default\" (click)=\"cancel.emit()\" [disabled]=\"cancelDisabled\">Cancel</button>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/dbm-components/dbm-edit/dbm-edit.component.html
// module id = 1885
// module chunks = 0